import { defineComponent as o, computed as m, openBlock as t, createElementBlock as l, Fragment as r, normalizeClass as i, toDisplayString as n, createCommentVNode as a } from "vue";
import { convertSpacings as s } from "../../../utils/tailwindUnitsConverter.js";
import { _ as c } from "../../../_plugin-vue_export-helper-dad06003.js";
const u = o({
  name: "VSubtitle",
  props: {
    level: {
      type: Number,
      validator(e) {
        return [2, 3, 4, 5, 6].indexOf(e) !== -1;
      },
      default: 3
    },
    size: {
      type: String,
      validator(e) {
        return ["l", "m", "s", "xs"].indexOf(e) !== -1;
      },
      default: "s"
    },
    color: {
      type: String,
      validator(e) {
        return ["dark", "grey", "white"].indexOf(e) !== -1;
      },
      default: "dark"
    },
    title: {
      type: String,
      default: void 0,
      required: !0
    },
    renderAs: {
      type: String,
      validator(e) {
        return ["h", "span"].indexOf(e) !== -1;
      },
      default: "h"
    },
    bottomSpacing: {
      type: String,
      default: "",
      validator: (e) => ["xs", "s", "m", "l", ""].includes(e)
    },
    topSpacing: {
      type: String,
      default: "",
      validator: (e) => ["xs", "s", "m", "l", "xl", ""].includes(e)
    },
    leftSpacing: {
      type: String,
      default: "",
      validator: (e) => ["xs", "s", "m", "l", "xl", ""].includes(e)
    },
    rightSpacing: {
      type: String,
      default: "",
      validator: (e) => ["xs", "s", "m", "l", "xl", ""].includes(e)
    },
    lineClamp: {
      type: String,
      validator: (e) => ["1", "2", "3", "4", ""].includes(e),
      default: ""
    }
  },
  setup(e) {
    return {
      classes: m(() => [
        "hobi-subtitle",
        "tw-font-obi tw-font-normal",
        e.color === "dark" ? "tw-text-gray-900" : "",
        e.color === "grey" ? "tw-text-gray-600" : "",
        e.color === "white" ? "tw-text-white" : "",
        e.size === "xs" ? "tw-text-base" : "",
        e.size === "s" ? "tw-text-lg" : "",
        e.size === "m" ? "tw-text-xl" : "",
        e.size === "l" ? "tw-text-2xl" : "",
        e.bottomSpacing !== "" ? "tw-mb-" + s(e.bottomSpacing) : "",
        e.topSpacing !== "" ? "tw-mt-" + s(e.topSpacing) : "",
        e.leftSpacing !== "" ? "tw-ml-" + s(e.leftSpacing) : "",
        e.rightSpacing !== "" ? "tw-mr-" + s(e.rightSpacing) : ""
      ])
    };
  }
}), p = ["data-line-clamp"], g = ["data-line-clamp"], f = ["data-line-clamp"], S = ["data-line-clamp"], h = ["data-line-clamp"], y = ["data-line-clamp"];
function v(e, d, w, k, b, C) {
  return t(), l(r, null, [
    e.renderAs === "h" ? (t(), l(r, { key: 0 }, [
      e.level === 2 ? (t(), l("h2", {
        key: 0,
        class: i(e.classes),
        "data-line-clamp": e.lineClamp
      }, n(e.title), 11, p)) : a("", !0),
      e.level === 3 ? (t(), l("h3", {
        key: 1,
        class: i(e.classes),
        "data-line-clamp": e.lineClamp
      }, n(e.title), 11, g)) : a("", !0),
      e.level === 4 ? (t(), l("h4", {
        key: 2,
        class: i(e.classes),
        "data-line-clamp": e.lineClamp
      }, n(e.title), 11, f)) : a("", !0),
      e.level === 5 ? (t(), l("h5", {
        key: 3,
        class: i(e.classes),
        "data-line-clamp": e.lineClamp
      }, n(e.title), 11, S)) : a("", !0),
      e.level === 6 ? (t(), l("h6", {
        key: 4,
        class: i(e.classes),
        "data-line-clamp": e.lineClamp
      }, n(e.title), 11, h)) : a("", !0)
    ], 64)) : a("", !0),
    e.renderAs === "span" ? (t(), l("span", {
      key: 1,
      class: i(e.classes),
      "data-line-clamp": e.lineClamp
    }, n(e.title), 11, y)) : a("", !0)
  ], 64);
}
const A = /* @__PURE__ */ c(u, [["render", v]]);
export {
  A as default
};
